var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","title":_vm.sectionTitle,"help-collapsed":_vm.sectionHelp}},[_c('kst-output',{attrs:{"field":"IsNeedDelivery","data":_vm.details,"catalog":_vm.Catalog}}),(_vm.details.IsNeedDelivery)?[_c('kst-output',{attrs:{"field":"DeliveryDate","data":_vm.details,"catalog":_vm.Catalog}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }